<template>
    <c-dialog ref="dialog" title="推送详情" mode="slide" width="50vw" mask-close :button="false">
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <span v-if="saasName" class="m-detail-saas">{{saasName}}</span>
            </div>
        </template>

        <div class="m-push-detail">
            <c-title>基础信息</c-title>
            <c-detail class="m-detail-table" column="2">
                <c-detail-item label="所属商户" colspan="2">{{saasName || '-'}}</c-detail-item>
                <c-detail-item label="推送渠道" colspan="2">{{row.channel_name || '-'}}</c-detail-item>
                <c-detail-item label="推送类型">
                    <c-state dict="SYNC_TYPE" :value="row.push_type"></c-state>
                </c-detail-item>
                <c-detail-item label="推送状态">
                    <c-state dict="PUSH_STATE" :value="row.push_state"></c-state>
                </c-detail-item>
                <c-detail-item label="推送价格">
                    <span class="m-amount">{{formatPrice(row.push_price)}}</span>
                </c-detail-item>
                <c-detail-item label="推送时间">{{row.push_time || '-'}}</c-detail-item>
                <c-detail-item label="失败原因" colspan="2">{{row.fail_reason || '-'}}</c-detail-item>
                <c-detail-item label="创建时间" colspan="2">{{row.create_date || '-'}}</c-detail-item>
            </c-detail>

            <c-title>产品信息</c-title>
            <c-detail class="m-detail-table" column="2">
                <c-detail-item label="商品" colspan="2">
                    <m-product-info :name="row.model_name" :level="row.level_type" :code="row.produce_unique_code" :imei="row.produce_imei"></m-product-info>
                </c-detail-item>
            </c-detail>
        </div>
    </c-dialog>
</template>

<script>
export default {
    name: 'erpPushDetail',

    data() {
        return {
            saasName: '',
            row: {}
        }
    },

    methods: {
        /*********打开抽屉（data=列表行）**********/
        open(data = {}) {
            this.saasName = data.saas_name || '';
            this.row = data || {};
            this.$refs.dialog.open();
        },

        /*********格式化价格**********/
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        }
    }
}
</script>

<style scoped>
.m-push-detail {
    padding: 0 20px 20px;
}

.m-detail-table ::v-deep .c-detail-item-label {
    background-color: #fafafa;
    color: #666;
    text-align: right;
}

.m-detail-table .m-amount {
    color: #e53e3e;
    font-weight: bold;
}

.m-detail-tag {
    gap: 8px;
    font-size: 14px;
    font-weight: bold;
}

.m-detail-saas {
    font-size: 12px;
    font-weight: normal;
    color: #999;
}
</style>
